import { Outlet } from 'react-router-dom';
import PageContainer from '../../../../components/common/PageContainer';
import EURTable from './Table';

const EURPage = () => {
  return (
    <>
      <PageContainer 
        title='Reports' 
        subTitle='Equipment Use & Performance Reports'
        submoduleTitle='Historical EURs'  
        showDate
      >
        <EURTable />
      </PageContainer>
      <Outlet />
    </>
  );
}

export default EURPage;